export default "__VITE_ASSET__Ca2QLimh__"